module.exports = __webpack_public_path__ + "static/media/HR.aabe0847.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/HR.svg
// module id = 271
// module chunks = 0